import { createSlotRecipe } from './runtime.js';

const layoutConfig = {"name":"layout","slots":["root","content"],"defaultVariants":{"padding":"0","scroll":"outer","width":"full"},"variantMap":{"padding":["0","12","16","2","20","24","32","4","40","6","8"],"scroll":["content","outer"],"width":["container","full"]}}

export const layout = /* @__PURE__ */ createSlotRecipe(layoutConfig)